import { render, staticRenderFns } from "./positionView.vue?vue&type=template&id=18e28ae4&scoped=true"
import script from "./positionView.vue?vue&type=script&lang=js"
export * from "./positionView.vue?vue&type=script&lang=js"
import style0 from "./positionView.vue?vue&type=style&index=0&id=18e28ae4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e28ae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e28ae4')) {
      api.createRecord('18e28ae4', component.options)
    } else {
      api.reload('18e28ae4', component.options)
    }
    module.hot.accept("./positionView.vue?vue&type=template&id=18e28ae4&scoped=true", function () {
      api.rerender('18e28ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/position_level_management/positionView/positionView.vue"
export default component.exports